import styled from 'styled-components'
import { grid, GridProps, height, HeightProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns'].includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  GridProps & GapProps
>`
  display: grid;
  width: 100%;

  ${grid}
  ${gap}
`

export const Card = styled.div<HeightProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;

  > img {
    object-fit: cover;
  }

  ${height}
`

export const Overflow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.overlay.image')};
`
